export default function HeroSection() {
  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[700px] flex items-center bg-background-50 overflow-hidden"
    >
      <div className="absolute inset-0 bg-gradient-to-br from-primary-50/60 via-background-50 to-accent-50/40"></div>

      <div className="relative w-full px-4 md:px-6 py-24 md:py-32">
        <div className="max-w-6xl mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-primary-100/80 text-primary-700 text-xs font-medium mb-6">
              <i className="ri-fire-line text-sm"></i>
              <span>韩漫·国漫·日漫</span>
            </div>

            <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-foreground-950 leading-tight">
              布丁漫画
              <br />
              <span className="text-primary-500">下拉式漫画阅读新体验</span>
            </h1>

            <p className="text-lg md:text-xl text-primary-400 font-heading mt-3 mb-6">
              滑动之间，故事无限
            </p>

            <p className="text-sm md:text-base text-foreground-600 leading-relaxed max-w-lg mx-auto lg:mx-0 mb-8">
              布丁漫画下拉式阅读专区，汇集海量韩漫、国漫、日漫全集资源。采用流畅的下拉式阅读模式，无需翻页即可一气呵成看完每一话，告别传统翻页的卡顿与等待。热门漫画每日更新，让你第一时间追上最新剧情，阅读体验丝滑不卡顿。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 mb-8">
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-heading font-bold text-primary-500">10000+</div>
                <div className="text-xs text-foreground-500 mt-1">漫画资源</div>
              </div>
              <div className="w-px h-10 bg-background-300"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-heading font-bold text-accent-500">每日更新</div>
                <div className="text-xs text-foreground-500 mt-1">热门追更</div>
              </div>
              <div className="w-px h-10 bg-background-300"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-heading font-bold text-primary-500">高清画质</div>
                <div className="text-xs text-foreground-500 mt-1">极致体验</div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#cards"
                className="inline-flex items-center gap-2 px-8 py-3.5 bg-primary-500 text-background-50 font-semibold text-sm rounded-full hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-play-circle-line text-lg"></i>
                开始阅读
              </a>
              <a
                href="#ranking"
                className="inline-flex items-center gap-2 px-8 py-3.5 bg-background-100 text-foreground-800 font-medium text-sm rounded-full hover:bg-background-200 transition-all duration-200 whitespace-nowrap cursor-pointer border border-background-200"
              >
                <i className="ri-fire-line text-lg"></i>
                热门推荐
              </a>
            </div>
          </div>

          <div className="flex-1 w-full flex justify-center lg:justify-end">
            <div className="relative w-[280px] h-[380px] md:w-[340px] md:h-[460px] rounded-2xl overflow-hidden bg-background-100">
              <img
                src="https://readdy.ai/api/search-image?query=Vibrant%20manga%20illustration%20featuring%20a%20dynamic%20action%20scene%20with%20a%20young%20protagonist%20in%20a%20urban%20fantasy%20setting%2C%20warm%20coral%20and%20amber%20color%20palette%2C%20modern%20webtoon%20style%20with%20clean%20lines%2C%20expressive%20character%20design%2C%20cinematic%20lighting%20with%20soft%20glow%2C%20digital%20art%20illustration%20for%20comic%20reading%20platform%20hero%20banner&width=680&height=920&seq=hero-comic-01&orientation=portrait"
                alt="布丁漫画下拉式阅读主视觉 - 漫画角色场景"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-background-950/20 to-transparent"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}